module.exports = {"420114001":"蔡甸街道","420114002":"奓山街道","420114003":"永安街道","420114004":"侏儒山街道","420114005":"大集街道","420114006":"张湾街道","420114007":"索河街道","420114008":"玉贤街道","420114070":"沌口街道","420114071":"军山街道","420114072":"沌阳街道","420114200":"消泗乡","420114400":"桐湖","420114401":"侏儒山街道洪北片区","420114404":"中法武汉生态示范城","420114406":"侏儒山街道成功片区","420114407":"蔡甸经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420114.json
// module id = 1830
// module chunks = 0